import { parse } from 'querystring';
import { NotificationModel } from '../../components/AccountNotifications';
import { ActionType, IntegrationStatus, IntegrationType } from '../api/types';
import { CreateUniqueId } from './Identifiers';

interface AccountLinkingResponse {
  actionableAction: boolean;
  integrationType?: IntegrationType;
  slug?: string;
  success?: boolean;
  accountStatus?: IntegrationStatus;
  action?: ActionType;
  accountId?: string;
}

export function AccountLinkingMessageHelper(action: ActionType, success: boolean, errorCode?: number) {
  switch (action) {
    case 'Configure':
      return success ? 'Account updated' : 'We were unable to update your account';

    case 'Link':
    case 'Install':
      return success ? 'You have successfully linked your account' : 'We were unable to link your account';

    case 'Delete':
      return success ? 'Account deleted' : 'We were unable to delete your account';

    case 'Renew':
      return success ? 'Account successfully renewed' : 'We were unable to renew your account';

    default:
      return success ? 'Success' : 'Failed';
  }
}

export function AccountLinkingResponseHelper(url: string): AccountLinkingResponse {
  //?IntegrationSlug=ebay&IntegrationType=Marketplace&Success=True&Action=Link&AccountId=EB61552&AccountStatus=Active

  var u = (url || window.location.href).split('?')[1];
  if (!u || u.indexOf('Action=') == -1) {
    return { actionableAction: false };
  }

  var parsed = parse(u);

  return {
    actionableAction: true,
    accountId: parsed.AccountId as string,
    accountStatus: parsed.AccountStatus as IntegrationStatus,
    action: parsed.Action as ActionType,
    integrationType: parsed.IntegrationType as IntegrationType,
    slug: parsed.IntegrationSlug as string,
    success: ((parsed.Success as string) || '').toLowerCase() === 'true',
  };
}

export function AccountActionResponseHelper(
  action: ActionType,
  integrationType: IntegrationType,
  integrationSlug: string,
  success: boolean,
  accountId: string,
  configRequired: boolean,
): NotificationModel {
  return {
    color: success ? 'success' : 'error',
    note: AccountLinkingMessageHelper(action, success),
    id: CreateUniqueId(),
    integrationSlug: integrationSlug,
    integrationType: integrationType,
    accountId: accountId,
    actions: [],
    showClose: true,
    configRequired: configRequired,
  };
}
